import React from "react";
import { PrimaryButton } from "../../shared/layout/PrimaryButton";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../shared/utils/translationUtils";
import { useProtocolsRouter } from "../../shared/custom-hooks/useProtocolsRouter";
import { useSyncPermissions } from "../../shared/custom-hooks/useSyncPermissions";
import {
  isOrgAdminOperationAllowed,
  isOrgCollaboratorOnlyOperationAllowed,
  isWorkspaceOwnerOperationAllowed,
} from "./permissions";

interface ProtocolsHeaderProps {
  title: string;
  showCreateButton: boolean;
  onCreate: () => void;
}

export const ProtocolsHeader = ({
  showCreateButton,
  onCreate,
}: ProtocolsHeaderProps): JSX.Element => {
  const { t } = useTranslation();

  const { workspaceId, orgId } = useProtocolsRouter();
  const { data: permissionsResponse } = useSyncPermissions({
    workspaceId,
    orgId,
  });
  const allowed = permissionsResponse?.allowed_operations ?? [];

  const isWorkspaceOwner = isWorkspaceOwnerOperationAllowed(allowed);
  const isOrgAdmin = isOrgAdminOperationAllowed(allowed);
  const isOrgCollaboratorOnly = isOrgCollaboratorOnlyOperationAllowed(allowed);
  const showProtocolCreate =
    (isWorkspaceOwner || isOrgAdmin) && !isOrgCollaboratorOnly;

  return (
    <>
      <div className="protocols-header">
        <h3 className="text-xl text-semibold">
          {formatTranslation(t("protocols.title"))}
        </h3>
        {showCreateButton && showProtocolCreate && (
          <PrimaryButton onClick={onCreate}>
            <PlusOutlined />
            {formatTranslation(t("protocols.createButton"))}
          </PrimaryButton>
        )}
      </div>
      <div className="flex-content-protocol">
        <p className="text-lg">
          {formatTranslation(t("protocols.protocolList"))}
        </p>
      </div>
    </>
  );
};
